<template>
    <div>
    </div>
</template>

<script>
    import {
        findUserInfoByCode,
        findLoginUserInfoByThirdId
    } from '@/service/api.js';
    import {
        findUserAppAndMenu,
        renderAppsData,
        composeAllAppMenuList,
        renderRouterByMenu
    } from '@/util/menu';
    import {
        registerAppByUser,
        setDefaultApp,
        startApp
    } from '@/util/qiankun';
    import {
        multiplevalInDeep
    } from '@/library/js/array.js';

    export default {
        name: "third-oauth",
        data () {
            return {
                code: this.$route.query.code // 第三方应用code
            }
        },
        methods: {
            /**
             * 跳转到第三方登录授权
             */
            oauthLogin () {
                if (!this.code) {
                    window.location.href = process.env.VUE_APP_THIRD_OAUTH_URL + "login-pc/index?redirect_url=" + process.env.VUE_APP_THIRD_REDIRECT_URL + "&app=" + process.env.VUE_APP_THIRD_APPID;
                } else {
                    this.getUserInfoByCode();
                }
            },
            /**
             * 跳转到第三方登录授权
             */
            async getUserInfoByCode () {
                this.$Message.loading({
                    content: '正在登录...',
                    duration: 0
                });
                const res = await findUserInfoByCode({
                    code: this.code
                });

                if (res && parseInt(res.code) === 1) {
                    document.cookie = "isOauthLogin=1;path=/";
                    this.getLoginUserInfoByThirdId(res.data.SourceId, res.data.OrgUserId,res.data.OrgId);
                } else {
                    this.$Message.destroy();
                    this.$Message.error(res.msg);
                    // 跳转到登录页
                }
            },
            /**
             * 通过第三方应用用户id获取同步用户信息
             */
            async getLoginUserInfoByThirdId (sourceId, orgUserId,orgId) {
                const res = await findLoginUserInfoByThirdId({
                    sourceId: sourceId,
                    orgUserId: orgUserId,
                    orgId: orgId
                });

                if (res && parseInt(res.code) === 1) {
                    if (typeof cef !== "undefined" && cef !== null) {
                        cef.message.sendMessage('mirco.tencent_platform', [JSON.stringify({
                            id: res.data.id
                        }), 'login']);
                    } else {
                        // 获取用户应用菜单权限 进入后台主页
                        this.getUserAuthAppMenuData(res.data.id);
                    }
                } else {
                    this.$Message.error(res.msg);
                    // 跳转到登录页
                }
            },
            /**
             * 获取用户应用菜单授权信息
             */
            getUserAuthAppMenuData (userId) {
                let userParam = {
                    userId: userId
                };
                this.$store.dispatch('user/getUserInfo', userParam).then(res => {
                    //根据用户id 获取用户权限（应用和应用的菜单）
                    let userMenuParam = {
                        userId: userId,
                        adminType: this.$store.getters.adminType,
                        userType: this.$store.getters.userType
                    };
                    findUserAppAndMenu(userMenuParam, () => {
                        //项目集合
                        let projects = this.$store.getters.projects;
                        //应用集合
                        let apps = this.$store.getters.apps;
                        //所有应用的菜单
                        let allAppMenuList = composeAllAppMenuList(apps);

                        let registAppData = renderAppsData(projects, apps, allAppMenuList);

                        //注册子项目
                        registerAppByUser(registAppData);

                        //根据当前路由path获取要加载的子项目、应用、菜单    （如果是根路径默认获取第一个菜单）
                        //根据当前路径遍历菜单集合
                        let targetMenu = multiplevalInDeep(allAppMenuList, this.routeName, '/', 'module', 'path', 'children');

                        let defaultProjectRP = '',
                            defaultAppId = '',
                            defaultPath = '',
                            defaultPathOpenMode = 0;
                        if (targetMenu.length > 0 && targetMenu[0].path != '') {
                            defaultOpenedsArr.push(targetMenu[0].parentId);
                            store.dispatch("menu/setSelectedMenuId", targetMenu[0].id);
                            defaultProjectRP = targetMenu[0].module;
                            defaultAppId = targetMenu[0].appId;
                            defaultPath = to.path;
                        } else {
                            defaultProjectRP = allAppMenuList[0].module;
                            defaultAppId = allAppMenuList[0].appId;
                            defaultPath = '/' + defaultProjectRP;
                            defaultPath += allAppMenuList[0].path || allAppMenuList[0].children[0].path;
                        }
                        store.dispatch("menu/setOpenedSubmenuArr", defaultOpenedsArr);

                        //设置默认应用
                        if (defaultAppId) {
                            let defaultApp = apps.filter(
                                item => item.id === defaultAppId
                            )[0];
                            if (defaultApp) {
                                store.dispatch("menu/setSelectedApp", defaultApp);
                                let defaultAppMenusData = renderRouterByMenu(defaultApp.menuTreeList, true);
                                store.commit('menu/SET_MENUS', defaultAppMenusData);
                            }
                        }
                        // 设置默认子应用
                        setDefaultApp(defaultProjectRP);

                        //启动微服务
                        startApp();
                        window.location.href = defaultPath;
                    });
                }).catch((res) => {
                    console.log(res);
                });
            }
        },
        mounted () {
            // 如果有code 直接根据code获取应用信息 无code 跳转到第三方登录授权
            if (this.code) {
                this.getUserInfoByCode();
                return;
            } else {
                this.oauthLogin();
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
